var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-file mb-3"},[_c('input',{ref:"uploadStateInput",staticClass:"custom-file-input",attrs:{"type":"file"},on:{"change":_vm.upload}}),_c('label',{staticClass:"custom-file-label"},[_vm._v("Load Configuration")])])}
var staticRenderFns = []

export { render, staticRenderFns }